import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/orders/$companyId/$shipToLocationId/_layout/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/orders/$companyId/$shipToLocationId/customer-purchase-orders",
      params,
    })
  },
})
